module.exports = __webpack_public_path__ + "static/media/arrow2.4ff01b61.svg";